function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable indent */
import React from 'react';
/**
 * @param {*} data - array of data to be composed as components.
 * @param {*} componentSelector - Switch function to return the correct component based on the level
 * @param {*} level  - the level/depth that the current object is in data.
 */

var componentGenerator = function componentGenerator(data, componentSelector) {
  var sharedProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (Array.isArray(data)) {
    return data.map(function (item, index) {
      var LeveledComponent = componentSelector(level);
      var nextLevel = level + 1;

      var _ref = item.props ? item.props : item,
          children = _ref.children;

      var renderChildren = typeof children !== 'undefined' && typeof children.length === 'undefined' ? [children] : children;
      return /*#__PURE__*/React.createElement(LeveledComponent, _extends({}, item.props, sharedProps, {
        level: level,
        index: index // eslint-disable-next-line react/no-array-index-key
        ,
        key: index
      }), componentGenerator(renderChildren, componentSelector, sharedProps, nextLevel));
    });
  }

  return false;
};

export default componentGenerator;